var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/* eslint-disable import/no-cycle */
import React from 'react';
import cuid from 'cuid';
import styled from '@empiriecom/module-components/utils/styled-components';
import ComponentItemType from './SchemaTypes';
import distanceVariants from '../../utils/distanceVariants';
import filterTimeControl from '../../utils/filterTimeControl';
import ComponentRecognizerItem from './RenderItem';
var ComponentRecognizerWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  &.distance-variation-1,\n  &.distance-default {\n    max-width: 71.25rem;\n  }\n\n  ", ";\n"], ["\n  width: 100%;\n  &.distance-variation-1,\n  &.distance-default {\n    max-width: 71.25rem;\n  }\n\n  ",
    ";\n"])), function (_a) {
    var type = _a.type;
    switch (type) {
        case ComponentItemType.FeedbackTeaser:
            return 'flex-grow: 1';
        case ComponentItemType.Html:
            return 'display: inline-flex';
        case ComponentItemType.Group:
        case ComponentItemType.ImageGroup:
        case ComponentItemType.SvgFile:
        case ComponentItemType.ImageSimple:
        case ComponentItemType.ImageFooter:
            return "\n          /* workaround for IE11 */\n          min-height: 1px;\n          min-width: 1px;\n\n          margin:0; \n          padding:0;\n        ";
        default:
            return 'margin:0; padding:0;';
    }
});
var ComponentRecognizer = function (_a) {
    var _b = _a.content, content = _b === void 0 ? undefined : _b;
    var id = cuid();
    if ((content === null || content === void 0 ? void 0 : content.length) && content.length > 0) {
        return (React.createElement(React.Fragment, null, content === null || content === void 0 ? void 0 : content.filter(function (item) {
            return filterTimeControl(item);
        }).map(function (item, index) {
            id = cuid();
            var itemID = cuid();
            var _a = item.field_footer_layout_variant, layoutVariant = _a === void 0 ? 'default' : _a;
            return (React.createElement(ComponentRecognizerWrapper, { className: "component-recognizer-container " + distanceVariants(item.field_distance) + " layout-variant-" + layoutVariant, "data-testid": "component-recognizer-container", key: id, type: item.type }, ComponentRecognizerItem(item, index, itemID)));
        })));
    }
    return React.createElement(React.Fragment, null);
};
export default ComponentRecognizer;
var templateObject_1;
//# sourceMappingURL=index.js.map